module.exports = __webpack_public_path__ + "img/bpvalue_bobocoin.gm.0595c2b.png";